module.exports = __webpack_public_path__ + "static/media/e&ohead2.910f16fe.jpg";